var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pad"},[_c('input',{staticClass:"uk-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.handleInput}}),_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.prettyName))])])}
var staticRenderFns = []

export { render, staticRenderFns }